import React, {Component} from 'react';
import Categories from './categories/Categories';
import Archive from './archive/Archive';

export default class Dashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            categories: [],
            issues: []
        };
    }

    componentDidMount() {
        this.refreshDashboard()
    }

    refreshCategories() {
        this.props.http.loadCategories()
            .then(categories => this.setState({categories: categories}));
    }

    refreshArchive() {
        this.props.http.loadIssues()
            .then(issues => this.setState({issues: issues}))
    }

    refreshDashboard() {
        this.refreshCategories();
        this.refreshArchive();
    }

    render() {
        return (
            <div>
                <div className="categories" id="categories">
                    <Categories http={this.props.http}
                                refreshCategories={this.refreshCategories.bind(this)}
                                refreshDashboard={this.refreshDashboard.bind(this)}
                                categories={this.state.categories} />
                </div>
                <div className="archive" id="archive">
                    <Archive http={this.props.http}
                             refreshDashboard={this.refreshDashboard.bind(this)}
                             issues={this.state.issues} />
                </div>
            </div>
        )
    }
}

Dashboard.propTypes = {
    http: React.PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/dashboard/Dashboard.js